import { SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";
import type { FormSelectProps } from "../../types";
import {
  FormSelectLabel,
  FormSelectStyle,
  FormSelectWrap,
} from "./FormSelect.style";

const FormSelect: React.FC<FormSelectProps> = ({
  placeholderTxt,
  labelTxt,
  margin,
  errorState,
  selectValue,
  handleChange,
  handleBlur,
  flex,
  requiredField,
  isDisabled,
  backgroundColor,
  hasError = false,
  showError = false,
  options = [],
}) => {
  return (
    <FormSelectWrap margin={margin} flex={flex}>
      {labelTxt && (
        <FormSelectLabel>
          {labelTxt}
          {requiredField && (
            <SpanTag fontWeight="bold" color={theme.redText2}>
              *
            </SpanTag>
          )}
        </FormSelectLabel>
      )}
      <FormSelectStyle
        onChange={handleChange}
        onBlur={handleBlur}
        value={selectValue || ""}
        hasError={hasError}
        id={labelTxt}
        disabled={isDisabled}
        backgroundColor={backgroundColor}
      >
        {placeholderTxt && (
          <option value="" disabled>
            {placeholderTxt}
          </option>
        )}
        {options.map((option) => (
          <option key={option.id} value={option.value}>
            {option.label}
          </option>
        ))}
      </FormSelectStyle>
      {showError && errorState && (
        <SpanTag
          fontSize="xs"
          margin="4px 0 0"
          color={theme.redText}
          fontWeight="bold"
        >
          {errorState}
        </SpanTag>
      )}
    </FormSelectWrap>
  );
};

export default FormSelect;
